import { Injectable } from '@angular/core';
import { MenuItem } from './menu.model';
import { MENU } from './menu';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/account/auth/auth.service';
import { TeamsService } from 'src/app/pages/table/teams.service';
import { AuthenticationService } from 'src/app/core/services/auth.service';


interface Permission {
  // Define the properties of a permission object here
  moduleName: string;
  // Other properties...
}
@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  toggled = false;
  modulePrivileges!:any[];
  currentModule:any;
  allModules: any;
  parent:any;
  routingPath: any[] = [];

  constructor(private authService:AuthenticationService,private teamsService: TeamsService,private location:Location,
    private router: Router, private route: ActivatedRoute) { }

  toggle() {
    this.toggled = ! this.toggled;
  }

  getSidebarState() {
    return this.toggled;
  }

  setSidebarState(state: boolean) {
    this.toggled = state;
  }

  getModuleData(link:any) {
    const pathList = MENU.filter(data => data.link === link);
  let subPathList: MenuItem[] = [];

  MENU.forEach(menu => {
    if (menu.subItems) {
      const subItem = menu.subItems.find((sub: MenuItem) => sub.link === link);
      if (subItem) {
        subPathList.push(subItem);
      }
    }
  });

  this.currentModule = pathList.length > 0 ? pathList:subPathList;
  this.authService.rolePrivelegesObservable$.subscribe((res) => {
    this.modulePrivileges = res;
    this.authService.accessVerificationObservable(this.modulePrivileges);
    if (this.modulePrivileges.length == 0 && this.currentModule.length > 0) {
      this.teamsService.getPrivilegesByRoleId(localStorage.getItem("roleID")).subscribe((res: any) => {
        this.authService.rolePrivelegesDataObservable(res.response);
        this.getPrivileges();
      });
    } else {
      this.getPrivileges();
    }
  });
  // Return pathList or subPathList based on your requirement
  // For example, return subPathList if it's what you need
  return subPathList;

    // let subpathList =MENU.filter(menu => (menu.subItems));
    // let subPathList = MENU.filter(menu => (menu.subItems).some((menu: { link: any; })=>menu.link == link));

    // let subPathList = ROUTES.filter(menu => (menu.submenu).some(menu=>menu.path == path));
    // let pathList = MENU.filter((data: MenuItem) => data.label == label)
    // let pathList = MENU.filter(data => data.link == link);
    // function findAllLabels(menu: any[], pathList: string[] = [],subpathList: string[] = []) {
    //   for (const item of menu) {
    //     if (item.label) {
    //       pathList.push(item.label);
    //     }
    //     if (item.subItems) {
    //       findAllLabels(item.subItems, subpathList);
    //     }
    //   }
    // }
    // function findAllLabels(menu: any[], pathList: string[] = [], subpathList: string[] = [], link: string) {
    //   for (const item of menu) {
    //     if (item.link) {
    //       if (item.link === link) {
    //         pathList.push(item.link);
    //       }
    //       if (item.subItems) {
    //         const subItem = item.subItems.find((subItems: { link: string; }) => subItems.link === link);
    //         if (subItem) {
    //           subpathList.push(subItem.link);
    //         }
    //       }
    //     }
    //     if (item.subItems) {
    //       findAllLabels(item.subItems, pathList, subpathList, link);
    //     }
    //   }
    // }


    // var pathList: string[] = [];
    // var subpathList: string[] = [];
    // findAllLabels(MENU, pathList,subpathList,link);



  }

  getPrivileges() {
    // var current =this.currentModule;
    let currentModulePrivileges = this.modulePrivileges.filter((x) => x.moduleName.toLowerCase() == this.currentModule[0]?.label.toLowerCase());
    this.authService.currentRolePrivelegesObservable(currentModulePrivileges);
    this.authService.accessVerificationObservable(this.modulePrivileges.filter((x) => x.moduleName.toLowerCase() == 'verification'));
    this.authService.importExportObservable(this.modulePrivileges.filter((x) => x.moduleName.toLowerCase() == 'import/export'));
    this.authService.accessRouterLinkObservable(this.modulePrivileges.filter((x) => x.moduleName.toLowerCase() == 'dashboard'));
    if (currentModulePrivileges.length > 0) {
      if(currentModulePrivileges[0].moduleName == "Teams"){
        if (
          currentModulePrivileges[0].moduleName == "Teams" &&
          currentModulePrivileges[0].isAdd == false &&
          currentModulePrivileges[0].isEdit == false &&
          currentModulePrivileges[0].isView == false &&
          currentModulePrivileges[0].isDelete == false &&
          !this.router.url.includes('/teams/add-team-member')

        ) {
          this.getRoutingPath();
        }
      }
      // if(currentModulePrivileges[0].moduleName == "Dashboard" && currentModulePrivileges[0].isAdd == false && currentModulePrivileges[0].isEdit == false && currentModulePrivileges[0].isView == false && currentModulePrivileges[0].isDelete == false ){
      //   this.getRoutingPath();
      // }

        // if(currentModulePrivileges[0].moduleName == "System Configuration" && currentModulePrivileges[0].isAdd == false && currentModulePrivileges[0].isEdit == false && currentModulePrivileges[0].isView == false && currentModulePrivileges[0].isDelete == false ){
        //   this.getRoutingPath();
        // }
      // if(currentModulePrivileges[0].moduleName != "Dashboard" ){
      else if (!currentModulePrivileges.find(privilege => (privilege.isAdd === true || privilege.isEdit === true || privilege.isView === true || privilege.isDelete === true))) {
        this.getRoutingPath();
      }
    // }
    }
  }

  getAccessPermission(moduleName: any): Promise<Permission[]> {
    const myPromise = new Promise<Permission[]>((resolve, error) => {
      this.teamsService.getPrivilegesByRoleId(localStorage.getItem('roleID')).pipe(
      ).subscribe({
        next: (permissions: any) => {
          resolve(permissions.response.filter((x: Permission) => x.moduleName == moduleName));
        },
      });
    });
    return myPromise;
  }

  getRoutingPath() {
    let finalRoutePath :any= [];
    let route = [];
    this.routingPath = [];
    this.authService.rolePrivelegesObservable$.subscribe((res) => this.allModules = res);
    let label :any=[];
    let pathList = JSON.stringify(MENU.filter(data => data));
    JSON.parse(pathList).filter((x:any) => {
      if (x.label != '') {
        label.push(x);
      } else {
        let menu :any=  [];
        menu.push(x);
        menu[0]?.submenu.forEach((ele:any) => {
          ele.title = menu[0].title;
          label.push(ele);
        })
      }
    });
    label.forEach((x:any) => {
      this.routingPath.push(this.allModules.filter((module:any) => x.title.toLowerCase() == module.moduleName.toLowerCase() && (module.isEdit == true || module.isAdd == true || module.isView == true || module.isDelete == true)))
    })
    this.routingPath.filter((x) => {
      if (x.length > 0) {
        finalRoutePath.push(x)
      }
    })
    route = label.filter((x:any) => x.label.toLowerCase() == finalRoutePath[0][0]?.moduleName.toLowerCase())
    finalRoutePath.length > 0 ? this.router.navigate([route[0]?.path]) : this.router.navigate(['/login']);
  }
}
